"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divide = exports.sum = exports.convert = exports.getSymbol = exports.SYMBOL_MAP = exports.getLabel = exports.LABEL_MAP_PLURAL = exports.LABEL_MAP_SINGULAR = exports.Mass = exports.UsMass = exports.ImperialMass = exports.Pound = exports.Ounce = exports.SiMass = exports.Kilogram = exports.Gram = exports.Milligram = exports.Microgram = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Unit.Mass';
exports.Microgram = effect_1.Schema.TaggedStruct('Microgram', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Microgram` });
exports.Milligram = effect_1.Schema.TaggedStruct('Milligram', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Milligram` });
exports.Gram = effect_1.Schema.TaggedStruct('Gram', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Gram` });
exports.Kilogram = effect_1.Schema.TaggedStruct('Kilogram', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Kilogram` });
exports.SiMass = effect_1.Schema.Union(exports.Microgram, exports.Milligram, exports.Gram, exports.Kilogram).annotations({
    identifier: `${exports.NAMESPACE}.SiMass`,
    description: 'A unit of mass within the International System of Units (SI)',
    documentation: 'https://en.wikipedia.org/wiki/International_System_of_Units',
});
exports.Ounce = effect_1.Schema.TaggedStruct('Ounce', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Ounce` });
exports.Pound = effect_1.Schema.TaggedStruct('Pound', {
    amount: effect_1.Schema.NonNegative,
}).annotations({ identifier: `${exports.NAMESPACE}.Pound` });
exports.ImperialMass = effect_1.Schema.Union(exports.Ounce, exports.Pound).annotations({
    identifier: `${exports.NAMESPACE}.ImperialMass`,
    description: 'A unit of mass within the imperial system of units',
    documentation: 'https://en.wikipedia.org/wiki/Imperial_units',
});
exports.UsMass = effect_1.Schema.Union(exports.Ounce, exports.Pound).annotations({
    identifier: `${exports.NAMESPACE}.UsMass`,
    description: 'A unit of mass within the United States customary system',
    documentation: 'https://en.wikipedia.org/wiki/United_States_customary_units',
});
exports.Mass = effect_1.Schema.Union(...exports.SiMass.members, ...exports.ImperialMass.members, ...exports.UsMass.members).annotations({
    identifier: `${exports.NAMESPACE}.Mass`,
    description: 'A unit of mass in any system of units',
});
exports.LABEL_MAP_SINGULAR = {
    Microgram: 'microgram',
    Milligram: 'milligram',
    Gram: 'gram',
    Kilogram: 'kilogram',
    Ounce: 'ounce',
    Pound: 'pound',
};
exports.LABEL_MAP_PLURAL = {
    Microgram: 'micrograms',
    Milligram: 'milligrams',
    Gram: 'grams',
    Kilogram: 'kilograms',
    Ounce: 'ounces',
    Pound: 'pounds',
};
/**
 * Retrieves the label corresponding to a given {@link Mass}-tag
 */
const getLabel = (mass) => mass.amount === 1 ? exports.LABEL_MAP_SINGULAR[mass._tag] : exports.LABEL_MAP_PLURAL[mass._tag];
exports.getLabel = getLabel;
exports.SYMBOL_MAP = {
    Microgram: 'mcg',
    Milligram: 'mg',
    Gram: 'g',
    Kilogram: 'Kg',
    Ounce: 'oz',
    Pound: 'lb',
};
/**
 * Retrieves the symbol corresponding to a given {@link Mass}-tag
 */
const getSymbol = (tag) => exports.SYMBOL_MAP[tag];
exports.getSymbol = getSymbol;
/**
 * Ratio between {@link Milligram} and other {@link Mass} unit of measure
 */
const FACTOR_MAP = {
    Microgram: 0.001,
    Milligram: 1,
    Gram: 1_000,
    Kilogram: 1_000_000,
    Ounce: 28_349.5,
    Pound: 453_592.37,
};
/**
 * Converts any {@link Mass} to a specific mass measure
 */
exports.convert = effect_1.Function.dual(2, (mass, outTag) => {
    const mg = mass.amount * FACTOR_MAP[mass._tag];
    return {
        _tag: outTag,
        amount: mg / FACTOR_MAP[outTag],
    };
});
/**
 * Sums {@link Mass} quantities and returns the result in the unit of measure of the 0th parameter
 */
const sum = (mass, ...args) => effect_1.Array.reduce(args, mass, (acc, mass) => ({
    ...acc,
    amount: acc.amount + (0, exports.convert)(mass, acc._tag).amount,
}));
exports.sum = sum;
const divide = (dividend, divisor) => ({
    ...dividend,
    amount: dividend.amount / (0, exports.convert)(divisor, dividend._tag).amount,
});
exports.divide = divide;
//# sourceMappingURL=mass.js.map